import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _FLAGS_DICTIONARY;

import { Locale } from "@types";
import deIcon from "../../images/languages/deIcon.svg";
import enIcon from "../../images/languages/enIcon.svg";
import plIcon from "../../images/languages/plIcon.svg";
export var FLAGS_DICTIONARY = (_FLAGS_DICTIONARY = {}, _defineProperty(_FLAGS_DICTIONARY, Locale.EN, enIcon), _defineProperty(_FLAGS_DICTIONARY, Locale.PL, plIcon), _defineProperty(_FLAGS_DICTIONARY, Locale.DE, deIcon), _FLAGS_DICTIONARY);